<template>
  <LinkCss
    :href="getWithHost(tailwindCss)"
    v-model:on-load-end="show"
  />
  <body v-show="show" data-theme="light">
    <BooksItems :items="items" @to_basket="basketStore.addBasketProduct($event.id)"
    :loading="basketStore.loading"
    ></BooksItems>
  </body>
</template>
<script lang="ts" setup>
import LinkCss from "@/components/LinkCss.vue"
import BooksItems from '@/components/BooksItems.vue'
import tailwindCss from '@/styles/style.css?url'
import { computed, ref } from 'vue'
import { getWithHost } from '@/utils/utils'
import { useBasketStore } from '@/stores/basket'
import type { BookItem } from '@/types/book_item'

const props = defineProps<{
  props: string
}>()

const basketStore = useBasketStore()

const items = computed((): BookItem[] => {
  const propsParsed = JSON.parse(props.props) as { items: BookItem[] }

  return propsParsed.items.map((v) => {
    const basketItem = basketStore.items.find(el => el.product_id == v.id) 
    // find(basketStore.items, ['product_id', v.id])
    if (!basketItem) {
      return v
    }
    return { ...v, in_bascet: true }
  })
})

const show = ref(false)
</script>
